import AddAvatarModal from './AddAvatarModal';

export default AddAvatarModal;
